export const OrderRouting = [
  {
    path: "/purchase/order/list",
    name: "purchase-order-list",
    meta: { title: "采购订单" },
    notice: { type: "purchase_order_examine", hasNotice: false },
    component: () =>
      import(/* webpackChunkName: "purchase-order" */ "@/views/purchase/order/list/index.vue"),
  },
  {
    hidden: true,
    path: "/purchase/order/create",
    name: "purchase-order-create",
    meta: { title: "新增采购订单", comName: "PurchaseOrderFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-order" */ "@/views/purchase/order/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/purchase/order/edit/:id",
    name: "purchase-order-edit",
    meta: { title: "编辑采购订单", comName: "PurchaseOrderFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-order" */ "@/views/purchase/order/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/purchase/order/detail/:id",
    name: "purchase-order-detail",
    meta: { title: "采购订单详情" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-order" */ "@/views/purchase/order/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/purchase/order/flowPrint/:id",
    name: "purchase-flowPrint-detail",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-order" */ "@/views/purchase/order/flow-print/index.vue"
      ),
  },
];
